import PromiseList from './PromiseList';

export default PromiseList;
